import { FunctionComponent } from "react";
import { StrictMode } from 'react';
import { AuthProvider } from './context/AuthContext';
import { BrowserRouter } from 'react-router-dom';


const AppWrapper: FunctionComponent<{ children: React.ReactNode }> = ({ children }) => (
    <StrictMode>
        <BrowserRouter>
            <AuthProvider>
                {children}
            </AuthProvider>
        </BrowserRouter>
    </StrictMode>
);

export default AppWrapper;